// extracted by mini-css-extract-plugin
var _1 = "icon__W5liT";
var _2 = "icon--size-10__bAbG2";
var _3 = "icon--size-12__KaR5M";
var _4 = "icon--size-14__dALya";
var _5 = "icon--size-16__R6Twg";
var _6 = "icon--size-160__D3_5X";
var _7 = "icon--size-18__VMh0z";
var _8 = "icon--size-20__t11pz";
var _9 = "icon--size-24__Kos8h";
var _a = "icon--size-30__G7nOz";
var _b = "icon--size-36__LXILv";
var _c = "icon--size-42__tReSA";
var _d = "icon--size-48__fdO2Z";
var _e = "icon--size-64__Baxtp";
export { _1 as "icon", _2 as "icon--size-10", _3 as "icon--size-12", _4 as "icon--size-14", _5 as "icon--size-16", _6 as "icon--size-160", _7 as "icon--size-18", _8 as "icon--size-20", _9 as "icon--size-24", _a as "icon--size-30", _b as "icon--size-36", _c as "icon--size-42", _d as "icon--size-48", _e as "icon--size-64" }
